import React, { useEffect, useState } from "react";
import PageHeader from "../../components/ui/PageHeader";
import AgentBodyComp from "../../components/ui/AgentBodyComp";
import { AxiosGet } from "../../api/api";
import Loading from "../../components/ui/Loading";

const Agents = () => {
  const [curPage, setCurPage] = useState(1);
  const url = `agents/?page=${curPage}&page_size=10`;
  const [isLoading, setIsLoading] = useState(false);
  const [agentData, setAgentData] = useState();
  const [data, setData] = useState({
    agentName: "",
    agentId: "",
    location: "",
  });
  const [dataErr, setDataErr] = useState({
    agentName: "",
    agentId: "",
    location: "",
  });
  const searchUrl = `agents/?search=${data?.agentName}&agentId=${data?.agentId}&location=${data?.location}&page=${curPage}&page_size=12`;

  const handleDataChange = (e) => {
    const newData = { ...data };
    newData[e.target.id] = e.target.value;
    setData(newData);
    const newDataErr = { ...dataErr };
    newDataErr[e.target.id] = "";
    setDataErr(newDataErr);
    // console.log(newData);
  };

  const clickNext = () => {
    setCurPage(agentData?.pagination?.nextPage);
  };
  const clickPrev = () => {
    setCurPage(agentData?.pagination?.previousPage);
  };

  const clickSearch = () => {
    setIsLoading(true);
    AxiosGet(searchUrl)
      .then((res) => {
        // console.log(res);
        setAgentData(res);
        setIsLoading(false);
      })
      .catch((err) => {
        // console.log(err.response);
        setIsLoading(false);
      });
  };

  const getAgents = () => {
    setIsLoading(true);
    AxiosGet(url)
      .then((res) => {
        // console.log(res);
        setAgentData(res);
        setIsLoading(false);
      })
      .catch((err) => {
        // console.log(err.response);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getAgents();
    // eslint-disable-next-line
  }, [curPage]);

  return (
    <div>
      <PageHeader title={"Landlord"} text={"Home/ Landlord"} />
      {isLoading && <Loading />}
      {!isLoading && (
        <AgentBodyComp
          agentData={agentData}
          clickNext={clickNext}
          clickPrev={clickPrev}
          changeInput={handleDataChange}
          searchBtn={clickSearch}
        />
      )}
    </div>
  );
};

export default Agents;
